import { useMemo } from "react";
import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Line,
} from "recharts";
import { EmptyScreen } from "../../../misc";
import { CustomXAxisTick, roundToTwoDecimalPlaces } from "./utils";

interface DecisionGraphProps {
  data: Array<{
    date: string;
    decisions: number;
  }>;
}

const DecisionGraph = ({ data }: DecisionGraphProps) => {
  const stackedData = useMemo(() => {
    if (!data || data.length === 0) return [];
    return data.map(entry => ({
      time: entry.date,
      decisions: roundToTwoDecimalPlaces(entry.decisions),
    }));
  }, [data]);

  if (stackedData && stackedData.length === 0)
    return (
      <EmptyScreen
        title="Start tracking soon"
        subTitle="Auto tune decisions is not started yet. Our datapilot will start tracking
      soon and you can see the progress"
      />
    );

  return (
    <ResponsiveContainer minHeight={400} className="mb-4">
      <LineChart
        data={stackedData}
        margin={{
          top: 50,
          right: 50,
          left: 50,
          bottom: 50,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" tick={<CustomXAxisTick />} />
        <YAxis
          label={{
            value: "No. of Decisions",
            fill: "black",
            angle: 0,
            position: "insideTopLeft",
            offset: -30,
          }}
        />
        <Tooltip />
        <Line
          type="stepBefore"
          dataKey="decisions"
          stroke="#247EFE"
          dot={{ strokeWidth: 2, fill: "#247EFE" }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default DecisionGraph;